// @ts-nocheck
import React, { useEffect, useState } from 'react';
import CombinedStats from '../../../common/CombinedStats';
import { DateForFilter } from '../../../../util/formatter';

import colours from '../../../../constants/colours';
import { scopes as tableScopes } from '../../../../constants/scopes';
import { statsModes } from '../../../../hooks/useAggregateStatsData';
import { useNavigate } from 'react-router-dom';

const WorkflowStats = ({ id, stats, getData }) => {
  const [_stats, _setStats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (stats) {
      _setStats([
        {
          colour: colours.STATS_OPEN_REQUESTS,
          linkto: `/requests/all?f_requestStatus=pending%20approval&${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Open requests',
          metric: stats.openRequests,
          primaryStat: true,
        },
        {
          colour: colours.STATS_OVER_SLA,
          linkto: `/requests/all?${tableScopes.ISOVERSLA}=true&${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Over SLA',
          metric: stats.overSLA,
          primaryStat: true,
        },
        {
          colour: colours.STATS_COMPLETED_REQUESTS,
          linkto: `/requests/all?f_requestStatus=authorised&${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Complete requests',
          metric: stats.completeRequests,
        },
        {
          colour: colours.STATS_KEYS_IN_POOL,
          linkto: `/keys/game?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Keys in pool',
          metric: stats.keysAvailable,
        },
        {
          colour: colours.STATS_KEYS_DELIVERED,
          linkto: `/keys/game?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Keys delivered',
          metric: stats.keysAllocated,
        },
        {
          colour: colours.STATS_KEYS_DELIVERED_VALUE,
          linkto: `/keys/game?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Keys delivered value',
          metric: stats.keyStockValue,
        },
        {
          colour: colours.STATS_KEYS_SOLD,
          linkto: `/keys/game?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Keys reported sold',
          metric: stats.keysSold,
        },
        {
          colour: colours.STATS_KEYS_DISABLED,
          linkto: `/keys/game?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Keys disabled',
          metric: stats.keysBlacklisted,
        },
        {
          colour: colours.STATS_ACCOUNTS,
          linkto: `/keys/accounts?${tableScopes.KEYWORKFLOW}=${id}`,
          title: 'Accounts',
          metric: stats.accountsTotal,
        },
        {
          colour: colours.STATS_ACCOUNT_DOWNLOADED,
          linkto: `/keys/accounts?${tableScopes.KEYWORKFLOW}=${id}&${tableScopes.ISDOWNLOADED}=true`,
          title: 'Accounts (downloaded)',
          metric: stats.accountsDownloadedKeys,
        },
        {
          colour: colours.STATS_GAME_COUNT,
          linkto: `/games?${tableScopes.KEYWORKFLOW}=${id}&groupBy=games`,
          title: 'Game count',
          metric: stats.gameCount,
        },
        {
          colour: colours.STATS_SKU_COUNT,
          linkto: `/games?${tableScopes.KEYWORKFLOW}=${id}&groupBy=sku`,
          title: 'SKU count',
          metric: stats.skuCount,
        },
      ]);
    }
  }, [id, stats]);

  return (
    <CombinedStats
      stats={_stats}
      getData={getData}
      setModeStorageKey={`workflow-stats-mode`}
      heatmapOnClick={(value) => {
        if (value) {
          let date = DateForFilter(value.date);
          let destination = `/requests/all?${tableScopes.KEYWORKFLOW}=${id}&f_requestedDateFrom=${date}&f_requestedDateTo=${date}`;
          navigate(destination);
        }
      }}
      id={id}
      mode={statsModes.KEYWORKFLOW}
    />
  );
};

export default WorkflowStats;
